import { en } from './en';

export type TranslationKeys = typeof en;

export const bn: TranslationKeys = {
  // Navigation
  nav: {
    home: 'হোম',
    profile: 'প্রোফাইল',
    schemes: 'প্রকল্প',
    applications: 'আবেদন',
    fraudCheck: 'জালিয়াতি পরীক্ষা',
    learnFinance: 'অর্থ শিখুন',
    appTitle: 'গ্রামীণ ডিজিটাল অধিকার',
  },

  // Home Page
  home: {
    welcome: 'গ্রামীণ ডিজিটাল অধিকারে স্বাগতম',
    subtitle: 'আপনার জন্য উপযুক্ত সরকারি প্রকল্প আবিষ্কার করুন',
    getStarted: 'শুরু করুন',
    createProfile: 'আপনার প্রোফাইল তৈরি করুন',
    browseSchemes: 'প্রকল্প ব্রাউজ করুন',
    checkEligibility: 'যোগ্যতা পরীক্ষা করুন',
  },

  // Profile Page
  profile: {
    title: 'আপনার প্রোফাইল',
    createTitle: 'আপনার প্রোফাইল তৈরি করুন',
    updateTitle: 'আপনার প্রোফাইল আপডেট করুন',
    subtitle: 'ব্যক্তিগত প্রকল্প সুপারিশ পেতে আমাদের আপনার সম্পর্কে বলুন',
    personalInfo: 'ব্যক্তিগত তথ্য',
    age: 'বয়স',
    gender: 'লিঙ্গ',
    male: 'পুরুষ',
    female: 'মহিলা',
    other: 'অন্যান্য',
    caste: 'জাতি শ্রেণী',
    general: 'সাধারণ',
    obc: 'ওবিসি',
    sc: 'এসসি',
    st: 'এসটি',
    occupation: 'পেশা',
    farmer: 'কৃষক',
    laborer: 'শ্রমিক',
    selfEmployed: 'স্ব-নিযুক্ত',
    salaried: 'বেতনভোগী',
    student: 'ছাত্র',
    unemployed: 'বেকার',
    incomeRange: 'বার্ষিক আয়ের সীমা',
    below1lakh: '₹১ লক্ষের নিচে',
    '1to3lakh': '₹১-৩ লক্ষ',
    '3to5lakh': '₹৩-৫ লক্ষ',
    '5to10lakh': '₹৫-১০ লক্ষ',
    above10lakh: '₹১০ লক্ষের উপরে',
    locationInfo: 'অবস্থানের তথ্য',
    state: 'রাজ্য',
    district: 'জেলা',
    pincode: 'পিনকোড',
    saveProfile: 'প্রোফাইল সংরক্ষণ করুন',
    updateProfile: 'প্রোফাইল আপডেট করুন',
    profileSaved: 'প্রোফাইল সফলভাবে সংরক্ষিত হয়েছে!',
    profileUpdated: 'প্রোফাইল সফলভাবে আপডেট হয়েছে!',
  },

  // Schemes Page
  schemes: {
    title: 'সরকারি প্রকল্প',
    subtitle: 'আপনি যোগ্য এমন প্রকল্প আবিষ্কার করুন',
    searchPlaceholder: 'প্রকল্প খুঁজুন...',
    filters: 'ফিল্টার',
    category: 'শ্রেণী',
    level: 'স্তর',
    central: 'কেন্দ্রীয়',
    state: 'রাজ্য',
    allCategories: 'সমস্ত শ্রেণী',
    agriculture: 'কৃষি',
    education: 'শিক্ষা',
    health: 'স্বাস্থ্য',
    housing: 'আবাসন',
    employment: 'কর্মসংস্থান',
    socialWelfare: 'সামাজিক কল্যাণ',
    viewDetails: 'বিস্তারিত দেখুন',
    applyNow: 'এখনই আবেদন করুন',
    eligibility: 'যোগ্যতা',
    estimatedBenefit: 'আনুমানিক সুবিধা',
    match: 'মিল',
    basedOnProfile: 'আপনার প্রোফাইলের উপর ভিত্তি করে',
    noSchemes: 'কোনো প্রকল্প পাওয়া যায়নি',
    createProfileFirst: 'ব্যক্তিগত সুপারিশ দেখতে আপনার প্রোফাইল তৈরি করুন',
    loading: 'প্রকল্প লোড হচ্ছে...',
    interestedQuestion: 'আপনি কি এই প্রকল্পে আগ্রহী?',
    interestedMessage: 'সুবিধাগুলি কীভাবে ব্যবহার করবেন সে সম্পর্কে ব্যক্তিগত আর্থিক পরামর্শ পেতে আপনি কি এই প্রকল্পটি সংরক্ষণ করতে চান?',
    yesInterested: 'হ্যাঁ, আমি আগ্রহী',
    noThanks: 'না, ধন্যবাদ',
    saving: 'সংরক্ষণ করা হচ্ছে...',
    noSchemesFound: 'কোনো প্রকল্প পাওয়া যায়নি',
    noSchemesFilters: 'আপনার বর্তমান ফিল্টারের সাথে কোনো প্রকল্প মেলে না। আপনার অনুসন্ধান বা ফিল্টার সামঞ্জস্য করার চেষ্টা করুন।',
    noSchemesAvailable: 'এই মুহূর্তে কোনো প্রকল্প উপলব্ধ নেই। অনুগ্রহ করে পরে আবার চেষ্টা করুন।',
    clearFilters: 'ফিল্টার সাফ করুন',
  },

  // Scheme Detail Dialog
  schemeDetail: {
    description: 'বিবরণ',
    officialWebsite: 'অফিসিয়াল ওয়েবসাইট',
    helpline: 'হেল্পলাইন',
    close: 'বন্ধ করুন',
    visitWebsite: 'অফিসিয়াল ওয়েবসাইট দেখুন',
    callHelpline: 'হেল্পলাইনে কল করুন',
  },

  // Applications Page
  applications: {
    title: 'আমার আবেদন',
    subtitle: 'আপনার প্রকল্প আবেদন ট্র্যাক করুন',
    noApplications: 'এখনও কোনো আবেদন নেই',
    startApplying: 'এখানে ট্র্যাক করতে প্রকল্পের জন্য আবেদন শুরু করুন',
    status: 'অবস্থা',
    submittedOn: 'জমা দেওয়া হয়েছে',
    referenceNumber: 'রেফারেন্স নম্বর',
    viewTimeline: 'টাইমলাইন দেখুন',
  },

  // Fraud Check Page
  fraudCheck: {
    title: 'জালিয়াতি সনাক্তকরণ',
    subtitle: 'একটি বার্তা বা কল প্রতারণা কিনা তা পরীক্ষা করুন',
    inputLabel: 'বার্তা লিখুন বা কলের বর্ণনা দিন',
    inputPlaceholder: 'বার্তা পেস্ট করুন বা কলার কী বলেছিল তা বর্ণনা করুন...',
    checkButton: 'জালিয়াতি পরীক্ষা করুন',
    checking: 'বিশ্লেষণ করা হচ্ছে...',
    result: 'বিশ্লেষণ ফলাফল',
    safe: 'নিরাপদ',
    risky: 'ঝুঁকিপূর্ণ',
    safeMessage: 'এটি বৈধ বলে মনে হচ্ছে',
    riskyMessage: 'এটি একটি সম্ভাব্য প্রতারণা বলে মনে হচ্ছে',
    explanation: 'ব্যাখ্যা',
  },

  // Education/Learn Finance Page
  education: {
    title: 'অর্থ শিখুন',
    subtitle: 'আপনার আগ্রহের প্রকল্পগুলিতে ব্যক্তিগত আর্থিক পরামর্শ পান এবং সুবিধাগুলি কীভাবে সর্বোত্তমভাবে ব্যবহার করবেন তা শিখুন',
    overallPlan: 'সামগ্রিক আর্থিক পরিকল্পনা',
    overallPlanDesc: 'সমস্ত থেকে সুবিধাগুলি পরিচালনা এবং ব্যবহার করার বিষয়ে ব্যাপক পরামর্শ পান',
    schemesCount: 'প্রকল্প একসাথে',
    getOverallAdvice: 'সামগ্রিক পরামর্শ পান',
    yourSchemes: 'আপনার আগ্রহের প্রকল্প',
    getAdvice: 'এই প্রকল্পগুলি থেকে সুবিধাগুলি কীভাবে সর্বোত্তমভাবে ব্যবহার করবেন সে সম্পর্কে ব্যক্তিগত আর্থিক পরামর্শ পান',
    noSchemes: 'এখনও কোনো আগ্রহের প্রকল্প নেই',
    noSchemesDesc: 'প্রকল্পগুলি ব্রাউজ করুন এবং ব্যক্তিগত আর্থিক পরামর্শ পেতে সেগুলিকে আগ্রহী হিসাবে চিহ্নিত করুন',
    getFinancialAdvice: 'আর্থিক পরামর্শ পান',
    financialAdvice: 'আর্থিক পরামর্শ',
    overallAdviceTitle: 'সামগ্রিক আর্থিক পরিকল্পনা',
    comprehensiveAdvice: 'এর জন্য ব্যাপক আর্থিক পরামর্শ',
    combinedAnalysis: 'আপনার সমস্ত আগ্রহের প্রকল্পের সম্মিলিত বিশ্লেষণ',
    generatingAdvice: 'ব্যক্তিগত আর্থিক পরামর্শ তৈরি করা হচ্ছে...',
    generatingPlan: 'ব্যাপক আর্থিক পরিকল্পনা তৈরি করা হচ্ছে...',
    overallAdviceLabel: 'সামগ্রিক পরামর্শ',
    keyPoints: 'মূল পয়েন্ট',
    utilizationTips: 'সুবিধাগুলি কীভাবে ব্যবহার করবেন',
    potentialImpact: 'সম্ভাব্য প্রভাব',
    removeScheme: 'প্রকল্প সরান',
  },

  // Common
  common: {
    retry: 'পুনরায় চেষ্টা করুন',
    loading: 'লোড হচ্ছে...',
    error: 'ত্রুটি',
    success: 'সফলতা',
    cancel: 'বাতিল করুন',
    confirm: 'নিশ্চিত করুন',
    save: 'সংরক্ষণ করুন',
    delete: 'মুছুন',
    edit: 'সম্পাদনা করুন',
    back: 'পিছনে',
    next: 'পরবর্তী',
    submit: 'জমা দিন',
    search: 'খুঁজুন',
    filter: 'ফিল্টার',
    clear: 'পরিষ্কার করুন',
    apply: 'প্রয়োগ করুন',
    close: 'বন্ধ করুন',
  },
};
